// Hoverintent
!function(e,t){if("function"==typeof define&&define.amd)define("hoverintent",["module"],t);else if("undefined"!=typeof exports)t(module);else{var n={exports:{}};t(n),e.hoverintent=n.exports}}(this,function(e){"use strict";var t=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(e[o]=n[o])}return e};e.exports=function(e,n,o){function i(e,t){return y&&(y=clearTimeout(y)),b=0,p?void 0:o.call(e,t)}function r(e){m=e.clientX,d=e.clientY}function u(e,t){if(y&&(y=clearTimeout(y)),Math.abs(h-m)+Math.abs(E-d)<x.sensitivity)return b=1,p?void 0:n.call(e,t);h=m,E=d,y=setTimeout(function(){u(e,t)},x.interval)}function s(t){return L=!0,y&&(y=clearTimeout(y)),e.removeEventListener("mousemove",r,!1),1!==b&&(h=t.clientX,E=t.clientY,e.addEventListener("mousemove",r,!1),y=setTimeout(function(){u(e,t)},x.interval)),this}function c(t){return L=!1,y&&(y=clearTimeout(y)),e.removeEventListener("mousemove",r,!1),1===b&&(y=setTimeout(function(){i(e,t)},x.timeout)),this}function v(t){L||(p=!0,n.call(e,t))}function a(t){!L&&p&&(p=!1,o.call(e,t))}function f(){e.addEventListener("focus",v,!1),e.addEventListener("blur",a,!1)}function l(){e.removeEventListener("focus",v,!1),e.removeEventListener("blur",a,!1)}var m,d,h,E,L=!1,p=!1,T={},b=0,y=0,x={sensitivity:7,interval:100,timeout:0,handleFocus:!1};return T.options=function(e){var n=e.handleFocus!==x.handleFocus;return x=t({},x,e),n&&(x.handleFocus?f():l()),T},T.remove=function(){e&&(e.removeEventListener("mouseover",s,!1),e.removeEventListener("mouseout",c,!1),l())},e&&(e.addEventListener("mouseover",s,!1),e.addEventListener("mouseout",c,!1)),T}});

class SiteHeader extends HTMLElement {

  constructor() {
    super();
    this.listeners();
  }

  listeners() {
    const navToggle = document.querySelector('.js-nav-toggle');
    const cartToggle = document.querySelector('.js-cart-toggle');
    const body = document.querySelector('body');
    const itemCount = this.querySelector('.js-item-count');

    this.touchBindings();
    this.hoverIntent();
    this.keyboardBindings();
    
    document.addEventListener('click', (e) => {
      const megaMenu = this.querySelector('.js-mega-menu');

      if (megaMenu && !megaMenu.contains(e.target)) {
        this.resetStates(true);
      }
    });

    if (navToggle) {
      navToggle.addEventListener('click', () => {
        body.classList.add('popout-nav-active');
      });
    }

    if (cartToggle) {
      cartToggle.addEventListener('click', () => {
        body.classList.add('popout-cart-active');
      });
    }

    document.addEventListener('cart:requestComplete', (e) => {
      let cartItemCount = 0;
      let cartItems = e.detail.data.items;

      cartItems.forEach((item) => {
        cartItemCount += item.quantity;
      });

      if (itemCount) {
        itemCount.innerText = cartItemCount;

        if (cartItemCount > 0) {
          itemCount.classList.remove('site-header__item-count--hidden');
        } else {
          itemCount.classList.add('site-header__item-count--hidden');
        }
      }
    });
  }

  openMenuItem(menuItem) {
    const body = document.querySelector('body');
    const menuItems = this.querySelectorAll('.js-mega-menu > li');

    menuItems.forEach((item) => {
      item.classList.remove('is-hover');
    });

    menuItem.classList.add('is-hover');
    body.classList.add('is-main-menu-active');
    document.dispatchEvent(new CustomEvent('megamenu:show'));
    document.dispatchEvent(new CustomEvent('searchDiscovery:close'));
  }

  closeMenuItem(menuItem) {
    const body = document.querySelector('body');
    const openItems = this.querySelectorAll('.js-mega-menu > li.is-hover');

    menuItem.classList.remove('is-hover');

    if (openItems.length <= 1 && openItems[0] === menuItem) {
      body.classList.remove('is-main-menu-active');
    }

    if (!this.querySelector('.js-mega-menu > li.is-hover')) {
      body.classList.remove('is-main-menu-active');
    }
  }

  keyboardBindings() {
    const menuItems = this.querySelectorAll('.js-mega-menu > li');

    menuItems.forEach((menuItem) => {
      if (menuItem.contains(menuItem.querySelector('.site-header__main-menu-dropdown'))) {

        menuItem.addEventListener('focusin', () => {
          this.openMenuItem(menuItem);
        });

        menuItem.addEventListener('focusout', () => {
          setTimeout(() => {
            if (!menuItem.contains(document.activeElement)) {
              this.closeMenuItem(menuItem);
            }
          }, 0);
        });
      }
    });
  }

  hoverIntent() {
    const body = document.querySelector('body');
    const menuItems = this.querySelectorAll('.js-mega-menu > li');
  
    const opts = {
      timeout: 350, 
      interval: 100,
      sensitivity: 7, 
      handleFocus: false 
    };

    menuItems.forEach((menuItem) => {
      if (menuItem.contains(menuItem.querySelector('.site-header__main-menu-dropdown'))) {

        hoverintent(menuItem,
          () => {
            this.openMenuItem(menuItem);
            body.classList.add('is-hovering');

            setTimeout(function(){
              body.classList.remove('is-hovering');
            }, 250);
          }, () => {
            if (!body.classList.contains('is-hovering')) {
              body.classList.remove('is-main-menu-active');
            }
            menuItem.classList.remove('is-hover');

          }).options(opts); 
      }
    });
  }

  touchBindings() {
    const body = document.querySelector('body');
    const menuItems = this.querySelectorAll('.js-mega-menu > li');

    menuItems.forEach(menuItem => {

      if (menuItem.contains(menuItem.querySelector('.site-header__main-menu-dropdown'))) {

        const menuLink = menuItem.querySelector('.site-header__main-menu-link');

        menuLink.addEventListener('touchstart', (e) => {
          if (!menuItem.classList.contains('is-hover')) {
            e.preventDefault();
          }
        }, { passive: false });

        menuItem.addEventListener('touchstart', ()  => {

          menuItems.forEach(menuItem => {
            if (menuItem.classList.contains('is-hover')) {
              menuItem.classList.remove('is-hover');
            }
          });

          menuItem.classList.add('is-hover');
          body.classList.add('is-main-menu-active');
          document.dispatchEvent(new CustomEvent('megamenu:show'));
          document.dispatchEvent(new CustomEvent('searchDiscovery:close'));
        }, {passive: true});
      }
    });
  }

  resetStates(removeActiveClass) {
    const body = document.querySelector('body');
    const menuItems = this.querySelectorAll('.js-mega-menu > li');

    if (body.classList.contains('is-main-menu-active')) {
      menuItems.forEach(menuItem => {
        menuItem.classList.remove('is-hover');
      });

      if (removeActiveClass) {
        body.classList.remove('is-main-menu-active');
      }
    }
  }
}

class PopoutNav extends HTMLElement {
  
  constructor(){
    super();
    this.listeners();
  }

  listeners(){
    const submenuShow = document.querySelectorAll('.js-sub-menu-show');
    const closeButtons = document.querySelectorAll('.js-popout-nav-close');
    const backButtons = this.querySelectorAll('.js-sub-menu-back');
    const shade = this.querySelector('.js-shade');

    submenuShow.forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        this.openMenu(el);
      });
    });

    document.addEventListener('popout-nav:close', () => {
      this.closeMenu.bind(this);
    });

    closeButtons.forEach((el) => {
      el.addEventListener('click', this.closeMenu.bind(this));
    });

    backButtons.forEach((el) => {
      el.addEventListener('click', this.closeSubMenu.bind(this));
    })
    
    if (shade) {   
      shade.addEventListener('click', this.closeMenu.bind(this));
    }
  }

  openMenu(target) {
    const popoutNav = document.querySelector('.js-popout-nav');
    const body = document.querySelector('body');

    if (!target) return;

    if (target.classList.contains('site-header__mobile-menu-link--is-open')) {
      target.classList.remove('site-header__mobile-menu-link--is-open');
    } else {
      const subMenus = document.querySelectorAll('.site-header__mobile-menu-sub-menu');

      target.classList.add('site-header__mobile-menu-link--is-open');
      body.classList.add('sub-menu-open');

      subMenus.forEach((el) => {
        if (el.classList.contains('site-header__mobile-menu-nested-sub-menu')) {
          const menuParentItem = el.parentElement.parentElement;

          if (el.previousElementSibling.classList.contains('site-header__mobile-menu-link--is-open')) {       
            body.classList.add('nested-sub-menu-open');
          }

          if (menuParentItem) {
            menuParentItem.scrollTop = 0;
          }        
        }
      });

      if (!popoutNav) return;

      popoutNav.scrollTop = 0;
    }
  }

  closeSubMenu(e) {
    let menuParentLink = e.target.parentElement.parentElement.previousElementSibling;
    const body = document.querySelector('body');

    if (!menuParentLink) {
      menuParentLink = e.target.parentElement.parentElement.parentElement.previousElementSibling;
    }

    if (menuParentLink && menuParentLink.classList.contains('site-header__mobile-menu-link--is-open')) {
      menuParentLink.classList.remove('site-header__mobile-menu-link--is-open');      
    } else {
      const menuParentLinks = this.querySelectorAll('.site-header__mobile-menu-link');

      menuParentLinks.forEach((el) => {
        if (el.classList.contains('site-header__mobile-menu-link--is-open')) {
          el.classList.remove('site-header__mobile-menu-link--is-open');
        }
      });
    }

    if (body.classList.contains('nested-sub-menu-open')) {
      body.classList.remove('nested-sub-menu-open');
    } else {
      body.classList.remove('sub-menu-open');
    }

    document.dispatchEvent(new CustomEvent('popout-search:blur'));
  }

  closeMenu() {
    const mobileNavItems = this.querySelectorAll('.site-header__mobile-menu-link');
    const body = document.querySelector('body');

    setTimeout(() => {
      mobileNavItems.forEach((el) => {

        el.classList.remove('site-header__mobile-menu-link--is-open');
      });

      body.classList.remove('sub-menu-open', 'nested-sub-menu-open')
    }, 250);

    body.classList.remove('popout-nav-active');

    document.dispatchEvent(new CustomEvent('popout-search:blur'));
  }
}

customElements.define('site-header', SiteHeader);
customElements.define('popout-nav', PopoutNav);
